module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.ee653992.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-Regular.ttf
// module id = 547
// module chunks = 0